module.exports = __webpack_public_path__ + "img/no-content.72e9aa45.png";